import { Loading, NoData } from "components/commons";
import { ACCESS_TOKEN, getItem } from "local-storage";
import moment from "moment";
import slugs from "navigation/slugs";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getUserTradeById } from "services/apis/apis";

export const TradeCard: React.FC<any> = (props: any) => {
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const f = async () => {
      if (!props?.state?.id) {
        setIsLoading(false);
        return;
      }
      try {
        setIsLoading(true);
        const result = await getUserTradeById(props?.state?.id);
        setData(result);
      } catch (error) {
        console.log("🚀 ~ file: HoldCard.tsx:21 ~ f ~ error:", error);
      } finally {
        setIsLoading(false);
      }
    };
    f();
  }, [props?.state?.id]);

  return (
    <div className="flex flex-col gap-4">
      {isLoading && <Loading />}

      {!isLoading && data?.length === 0 && <NoData />}

      {data?.map((el: any) => (
        <div
          className="border-2 rounded-xl border-gray-800 w-full"
          key={el?.id}
          onClick={(e) => {
            e.preventDefault();
            navigate(`${slugs.profile}/${el?.trader_tiktok_user_id}`);
          }}
        >
          <div className={`flex p-4 gap-4 justify-between items-center `}>
            <div className="flex items-center gap-2 w-full">
              <div className="flex">
                <div className="h-12 w-12 shadow-sm rounded-full overflow-hidden flex justify-center items-center">
                  <img
                    className="h-12 w-12 shadow-sm rounded-full object-fill"
                    // src={item?.metadata?.avatar_168x168}
                    src={el?.trader_url}
                    alt=""
                  />
                </div>
                <div className="h-12 w-12 shadow-sm rounded-full overflow-hidden flex justify-center items-center -translate-x-3">
                  <img
                    className="h-12 w-12 shadow-sm rounded-full object-fill"
                    // src={item?.metadata?.avatar_168x168}
                    src={el?.subject_url}
                    alt=""
                  />
                </div>
              </div>

              {/* {item?.metadata?.avatar_168x168 ? (
            <img
              className="h-12 w-12 shadow-sm rounded-full object-fill"
              src={item?.metadata?.avatar_168x168}
            />
          ) : (
            <i className="fa-duotone fa-user text-2xl text-primary"></i>
          )} */}

              <div className="flex-1 flex justify-between">
                <h6 className="flex flex-col items-baseline transition-all">
                  <span className={`text-sm font-normal leading-none mr-1`}>
                    <span className="text-secondary">
                      {el?.trader_nickname}
                    </span>{" "}
                    just {el?.share_amount > 0 ? "bought" : "sold"}{" "}
                    {Math.abs(el?.share_amount)}
                    <span
                      className="text-secondary"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        navigate(-1);
                      }}
                    >
                      {" "}
                      {el?.subject_nickname}
                    </span>{" "}
                    Share
                  </span>
                  <span className="text-xs font-normal text-slate-500">
                    {el?.eth_amount} ETH{" "}
                    <span className="font-bold text-xl" role="separator">
                      ·
                    </span>{" "}
                    {moment(el?.created_at).fromNow()}
                  </span>
                </h6>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
